// DocLink renders a clickable reference to a document. Extracted from
// Overview.jsx as part of JOBE-0044.5 so the document-detail page can
// reuse the same component for provenance chips.
//
// When the URN names a `urn:jobe:document:…` entity, the component
// renders an anchor to the BFF's download endpoint (JOBE-0091) that
// opens the underlying artifact in a new tab. Anything else (no URN,
// or a non-document URN like a calendar event) renders as plain text —
// the BFF wouldn't have a useful click target for it.
//
// `rel="noopener noreferrer"` mirrors the rest of the SPA's outbound-
// link posture: blocks window.opener access and prevents referer leak
// to the GCS-signed-URL destination. The signed URL is short-TTL
// (~15m) but still URL-substrate noise we shouldn't broadcast.
export function DocLink({ urn, label }) {
  const text = label || urn || '';
  if (urn && urn.startsWith('urn:jobe:document:')) {
    return (
      <a
        href={`/api/documents/${encodeURIComponent(urn)}/download`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {text}
      </a>
    );
  }
  return text;
}
